var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',{ref:"iconContainerRef",staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(_vm.svgStr)}})}
var staticRenderFns = []

export { render, staticRenderFns }